<div class="loading-container">
  <mat-spinner></mat-spinner>
  <p>{{ 'PROCESSING_REGISTRATION' | translate }}</p>
</div>